import { dataAxios, gatewayAxios } from 'util/Api';

import {
  SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  FETCH_PROCESSORS_START,
  FETCH_PROCESSORS_ERROR,
  FETCH_PROCESSORS_SUCCESS,
  FETCH_PROCESSOR_START,
  FETCH_PROCESSOR_ERROR,
  FETCH_PROCESSOR_SUCCESS,
  FETCH_PROCESSOR_TRANS_STATS_START,
  FETCH_PROCESSOR_TRANS_STATS_ERROR,
  FETCH_PROCESSOR_TRANS_STATS_SUCCESS,
  ADD_PROCESSOR_ERROR,
  ADD_PROCESSOR_START,
  ADD_PROCESSOR_SUCCESS,
  DELETE_PROCESSOR_START,
  DELETE_PROCESSOR_SUCCESS,
  DELETE_PROCESSOR_ERROR,
  UPDATE_PROCESSOR_START,
  UPDATE_PROCESSOR_SUCCESS,
  UPDATE_PROCESSOR_ERROR,
} from '../../constants/ActionTypes';

// TRANS_STATS_
export const getProcessorTransactionStats = (code, currency, params) => (dispatch) => {
  dispatch({ type: FETCH_PROCESSOR_TRANS_STATS_START });
  gatewayAxios.get(`ipns/transactions/stats/${code}/${currency}${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    const page = Number(headers['content-range'].split('-')[0]);
    const limit = Number(headers['content-range'].split('-')[1].split('/')[0]);
    const totalItems = data?.records?.length || 0;
    dispatch({
      type: FETCH_PROCESSOR_TRANS_STATS_SUCCESS,
      payload: data.data,
      meta: {
        page,
        pageTotal: (totalItems >= limit) ? (page * limit + limit) : page * limit,
      },
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_PROCESSOR_TRANS_STATS_ERROR, payload: error.response.data.message });
    }
  });
};

export const getProcessorById = (id) => (dispatch) => {
  dispatch({ type: FETCH_PROCESSOR_START });
  dataAxios.get(`processors/${id}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const { data } = response;
    dispatch({
      type: FETCH_PROCESSOR_SUCCESS,
      payload: data,
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_PROCESSOR_ERROR, payload: error.response.data.message });
    }
  });
};

export const getProcessors = (params) => (dispatch) => {
  dispatch({ type: FETCH_PROCESSORS_START });
  dataAxios.get(`processors/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    const currentPage = Number(headers['content-range'].split('-')[0]);
    const totalRecords = Number(headers['content-range'].split('/')[1]);
    const payload = { data: data.data, totalRecords, currentPage };

    dispatch({
      type: FETCH_PROCESSORS_SUCCESS,
      payload,
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_PROCESSORS_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const getProcessorsById = (merchantId, params = '') => (dispatch) => {
  dispatch({ type: FETCH_PROCESSORS_START });
  dataAxios.get(`processors/merchant/${merchantId}/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };
    dispatch({ type: FETCH_PROCESSORS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: 'Error while fetching processors' });
    }
    dispatch({ type: FETCH_PROCESSORS_ERROR });
    console.error(error);
  });
};

export const addProcessor = (Processor) => (dispatch) => {
  dispatch({ type: ADD_PROCESSOR_START });
  dataAxios.post('/processors', Processor).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response.data && response.data.name !== 'MongoError') {
      dispatch({ type: ADD_PROCESSOR_SUCCESS, payload: response.data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added processor: ${response.data.name}` });
    } else {
      dispatch({ type: ADD_PROCESSOR_ERROR, payload: response.data.name });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding this" });
      console.error('Error: ', response.data.name);
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: ADD_PROCESSOR_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const addMid = (Processor) => (dispatch) => {
  dispatch({ type: ADD_PROCESSOR_START });
  dataAxios.post('/mids', Processor).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response.data && response.data.name !== 'MongoError') {
      dispatch({ type: ADD_PROCESSOR_SUCCESS, payload: response.data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added Mid: ${response.data.name}` });
    } else {
      dispatch({ type: ADD_PROCESSOR_ERROR, payload: response.data.name });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding this" });
      console.error('Error: ', response.data.name);
    }
  }).catch((error) => {
    if (error.response && error.response.message) {
      dispatch({ type: ADD_PROCESSOR_ERROR, payload: error.response.message });
    }
    console.error('Error: ', error.message);
  });
};

export const deleteProcessor = (ProcessorId) => (dispatch) => {
  dispatch({ type: DELETE_PROCESSOR_START });
  dataAxios.delete(`/processors/${ProcessorId}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: DELETE_PROCESSOR_SUCCESS, payload: ProcessorId });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble deleting this" });
    }
    dispatch({ type: DELETE_PROCESSOR_ERROR });
    console.error('Error: ', error.message);
  });
};

export const updateProcessor = (ProcessorId, values) => (dispatch) => {
  dispatch({ type: UPDATE_PROCESSOR_START });
  dataAxios.put(`/processors/${ProcessorId}`, values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: UPDATE_PROCESSOR_SUCCESS, payload: response.data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Succesfully updated processor' });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: UPDATE_PROCESSOR_ERROR });
    console.error('Error: ', error.message);
  });
};
